import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import UserDetailsCard from "./UserDetailsCard";
import UserProfilePictureCard from "./UserProfilePictureCard";
import UserPasswordCard from "./UserPasswordCard";
import { useApi } from "../../utils/Api";
import Preloader from "../Preloader";
import FilterGroupsCard from "./FilterGroupsCard";
import { hasAccess, accessKeys } from "../../utils/userAccess";

export default function UserSettings(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [profile, setProfile] = useState({});
  const api = useApi();

  async function loadUserProfile() {
    const response = await api.fetch(`${import.meta.env.VITE_MAIN_URL}profiles`, false, "GET");
    !!response && setProfile(response);
    setIsLoading(false);
  }

  useEffect(() => {
    loadUserProfile();
  }, []);

  return (
    <Grid
      container
      rowSpacing={2}
      columnSpacing={3}
      wrap="nowrap"
      direction={{ xs: "column", md: "row" }}
      justifyContent={{ xs: "flex-start", md: "center" }}
    >
      {isLoading && <Preloader />}
      <Grid>
        <UserProfilePictureCard
          url={profile?.actor?.profilePictureUrl}
          name={profile?.name}
          actorId={profile?.actor?.actorId}
          onImageChange={() => loadUserProfile()}
        />
      </Grid>
      <Grid container direction="column" rowSpacing={2} className="userSettingsDetailsCol" size={{ xs: 12, md: 8 }}>
        <Grid>
          <UserDetailsCard profile={profile} />
        </Grid>
        {hasAccess(accessKeys.advancedPackage, accessKeys.courseAdmin) && (
          <Grid>
            <FilterGroupsCard />
          </Grid>
        )}
      </Grid>
      <Grid>
        <UserPasswordCard />
      </Grid>
    </Grid>
  );
}
